import React from "react";

const CalorieDisplay = ({ calories }) => {
  return (
    <div
      style={{
        background: "rgba(0,0,0,0.8)",
        padding: "15px 20px",
        borderRadius: "10px",
        color: "white",
        fontSize: "24px",
        fontWeight: "bold",
        minWidth: "200px",
      }}
    >
      <div style={{ fontSize: "28px", color: "#ff9800" }}>
        🔥 {calories.toFixed(2)} kcal
      </div>
      <div style={{ fontSize: "14px", color: "#aaa", marginTop: "5px" }}>
        Calories Burned
      </div>
    </div>
  );
};

export default CalorieDisplay;
